import React, { useState } from 'react';
import PosMappingPickerModal from './pos-mapping-picker-modal';
import usePosMappingAccess from './use-pos-mapping-access';
import TWConfirmModal from '../../ui/tw-confirm-modal';
import { TWButton } from '../../ui';

const MAPPING_WARNING =
  'Changing POS mapping may affect how orders are sent to Square. Please make sure this item matches the correct Square POS item.';
const UNMAPPED_INFO =
  'This item is not linked to Square. It will be sent as a custom line item and may not appear correctly in Square inventory or item reports.';
const MISSING_WARNING =
  'This item no longer exists in Square and has been hidden from the live menu.';

const PosMappingSection = ({ level, squareid, squarename, squaremissing, onChange }) => {
  const { canEdit } = usePosMappingAccess();
  const [pickerOpen, setPickerOpen] = useState(false);
  const [confirmOpen, setConfirmOpen] = useState(false);
  const [pending, setPending] = useState(null); // { id, name } awaiting confirm

  if (!canEdit && !squareid) return null;

  return (
    <div className="rounded-md border border-slate-200 p-3 dark:border-slate-600">
      <p className="text-sm font-medium text-gray-700 dark:text-slate-400">
        POS Mapping (Square)
      </p>
      {squareid ? (
        <p className="mt-1 text-sm text-gray-600 dark:text-slate-300">
          Square: <span className="font-semibold">{squarename || squareid}</span>
          {squaremissing && (
            <span className="ml-2 inline-flex items-center rounded-full border border-rose-300 bg-rose-100 px-1.5 py-0.5 text-[0.6rem] font-semibold uppercase text-rose-700 dark:border-rose-500/50 dark:bg-rose-900/30 dark:text-rose-200">
              Missing in Square
            </span>
          )}
        </p>
      ) : (
        <p className="mt-1 text-xs text-gray-500 dark:text-slate-400">{UNMAPPED_INFO}</p>
      )}
      {squaremissing && (
        <p className="mt-1 text-xs text-rose-600 dark:text-rose-300">{MISSING_WARNING}</p>
      )}
      {canEdit && (
        <div className="mt-2 flex gap-2">
          <TWButton
            variant="default"
            size="sm"
            label={squareid ? 'Change mapping' : 'Assign Square item'}
            onClick={() => setPickerOpen(true)}
          />
          {squareid && (
            <TWButton
              variant="danger"
              size="sm"
              label="Remove mapping"
              onClick={() => {
                setPending({ id: '', name: '' });
                setConfirmOpen(true);
              }}
            />
          )}
        </div>
      )}
      <PosMappingPickerModal
        open={pickerOpen}
        level={level}
        onClose={() => setPickerOpen(false)}
        onSelect={(id, name) => {
          setPending({ id, name });
          setConfirmOpen(true);
        }}
      />
      <TWConfirmModal
        open={confirmOpen}
        onClose={() => setConfirmOpen(false)}
        onConfirm={() => {
          onChange(pending.id, pending.name);
          setConfirmOpen(false);
        }}
        title="Change POS mapping?"
        description={MAPPING_WARNING}
        confirmLabel="Confirm"
        tone="warning"
      />
    </div>
  );
};

export default PosMappingSection;
